var React = require('react');

function ArrowRightMini (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st85{fill:none;stroke:#1C7CD5;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;}\n"),React.createElement("path",{"id":"Trazado_10","className":"st85","d":"M1.5,14.4l7.6-6.7L1.5,1.5","key":1})]);
}

ArrowRightMini.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 10.6 15.9","style":{"enableBackground":"new 0 0 10.6 15.9"},"xmlSpace":"preserve"};

module.exports = ArrowRightMini;

ArrowRightMini.default = ArrowRightMini;
